<div class="d-flex align-items-center my-1 px-1">
  @if (props.label) {
    <div class="text w-50" matTooltip="{{ props.tooltip ? (props.tooltip | apmTranslate) : undefined }}">
      {{ props.suppressLabelTranslation ? props.label : (props.label | apmTranslate) }}
      @if (props.uom) {
        <span>[{{ props.uom }}]</span>
      }
      @if (canDebug && props.label) {
        <br />
        <span style="font-size: 8px">{{ field.key }} {{ props.name }}</span>
      }
    </div>
  }
  @if (props.resourceId) {
    <div class="text w-50">
      {{ props.resourceId | apmTranslate }}
    </div>
  }

  @let iconResourceId = props.iconResourceId;
  <div class="d-flex flex-column w-50">
    <div class="apm-field-wrapper d-flex flex-column" [class.with-image-icon]="!!iconResourceId">
      @if (iconResourceId) {
        <img class="apm-field-icon apm-prefix-field-icon" [apmResourceImage]="iconResourceId" />
      }
      <input
        class="apm-input w-100"
        type="number"
        [formControl]="formControl"
        [formlyAttributes]="field"
        (keydown)="onKeyDown($event)"
      />
    </div>
    @if (formControl.errors?.min) {
      <div class="d-block invalid-feedback">Min value allowed is {{ formControl.errors?.min.min }}</div>
    }
    @if (formControl.errors?.max) {
      <div class="d-block invalid-feedback">Max value allowed is {{ formControl.errors?.max.max }}</div>
    }
  </div>
</div>
